import $ from 'jquery';
import * as CONST from '../../common/utils/constants';
import Util from '../../common/utils/ui';

class AgentSearch {
    constructor() {
    }

    init() {
        let position = null;
        this.bindEvents();
        this.agentTypeSelect();
        //this.getGeolocation();
    }

    agentTypeSelect() {
        let opened = false;
        $('.js-agent-type').on('click', () => {
            if (!opened)
            {
                $('.js-agent-type').removeClass('js-agent-type-down');
                $('.js-agent-type').addClass('js-agent-type-up');
                opened = true;
            }
            else
            {
                $('.js-agent-type').removeClass('js-agent-type-up');
                $('.js-agent-type').addClass('js-agent-type-down');
                opened = false;
            }
        });
    }

    bindEvents() {
        $('.js-agent-search').on('click', (e) => {
            e.preventDefault();

            let findAgentUrl = '/find-an-agent/';
            let agentType = $('.js-agent-type').val();
            let zipCode = $('.js-agent-zipcode').val();

            if (zipCode !== null && zipCode !== '') {
                if (this.isZipCode(zipCode)) {
                    window.location.href = `${findAgentUrl}?zipcode=${zipCode}&agenttype=${agentType}`;
                    this.clearError();
                }
                else {
                    this.showError();
                }
            }
            else {
                this.showError();
            }
        });
    }

    getGeolocation() {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
                    let lat = position.coords.latitude;
                    let long = position.coords.longitude;
                    let point = new google.maps.LatLng(lat, long);
                    new google.maps.Geocoder().geocode(
                        { latLng: point },
                        (res, status) => {
                            let zipCode = res[0].formatted_address.match(/,\s\w{2}\s(\d{5})/);
                            
                            $('.js-agent-zipcode').val(zipCode[1]);
                        }
                    );
                });
        }
    }

    isZipCode(str) {
        const regexp = /^[0-9]{5}(?:-[0-9]{4})?$/;
        if (regexp.test(str)) {
            return true;
        } else {
            return false;
        }
    }

    showError() {
        $('.js-agent-zipcode').addClass('form-error');
        $('.js-agent-error').fadeIn();
        $('#zipcode').attr('aria-invalid', 'true');
        $('#zipcode').focus();
    }

    clearError() {
        $('.js-agent-zipcode').removeClass('form-error');
        $('.js-agent-error').fadeOut();
        $('#zipcode').attr('aria-invalid', 'false');
    }
}

export default AgentSearch;

$(() => {
	const agentSearch = new AgentSearch();
	agentSearch.init();
});